import { languageService } from "@/lib/api/services/language";
import { useMutation, useQuery } from "@tanstack/react-query";

export function useLanguageQuery() {
  return useQuery({
    queryKey: ["language"],
    queryFn: () => languageService.getLanguage(),
  });
}

export function useLanguageMutation() {
  return useMutation({
    mutationKey: ["update-language"],
    mutationFn: (request: string) => languageService.update(request),
  });
}
